import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  messageContainer: {
    maxHeight: '50%',
    flex: 1,
  },
  message: {
    border: '1px solid #576871',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
  },
  checkbox: {
    padding: 0,
    color: 'white',
    '&.Mui-checked': {
      color: theme.palette.secondary.main,
    },
  },
  progressBar: {
    borderRadius: 4,
    height: 4,
    backgroundColor: 'rgba(255,255,255,0.1)',
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  previewContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: '0.5rem',
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    scrollbarWidth: 'thin',
    padding: '8px 0',
    '&::-webkit-scrollbar': {
      height: 4,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(255,255,255,0.3)',
      borderRadius: 2,
    },
  },
  previewItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: '80px',
    maxWidth: '100px',
    cursor: 'pointer',
    borderRadius: 4,
    border: '2px solid transparent',
    padding: 4,
    transition: 'border-color 0.2s ease',
    '&:hover': {
      borderColor: 'rgba(255,255,255,0.3)',
    },
  },
  previewItemSelected: {
    borderColor: theme.palette.secondary.main,
  },
  previewImageWrapper: {
    width: '100%',
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.05)',
    borderRadius: 4,
    overflow: 'hidden',
  },
  previewImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  previewFooter: {
    display: 'flex',
    flexDirection: "column",
    alignItems: 'center',
    marginTop: 2,
    width: '100%',
  },
  previewCheckbox: {
    padding: 2,
    color: 'rgba(255,255,255,0.5)',
    '&.Mui-checked': {
      color: theme.palette.secondary.main,
    },
  },
  previewLabel: {
    fontSize: '0.6rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },
  sendAsSelect: {
    fontSize: '0.7rem',
    color: 'rgba(255,255,255,0.8)',
    '& .MuiSelect-select': {
      padding: '2px 20px 2px 4px',
      fontSize: '0.7rem',
    },
    '& .MuiSelect-icon': {
      color: 'rgba(255,255,255,0.5)',
      fontSize: '1.2rem',
      right: 0,
    },
  },
}));
